import React, { useEffect, useState } from "react";
import user from "../../../assets/images/dw20/user2.png";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  slide_bounce_variants,
  slide_bounce_down_variants
} from "shared/components/animations";
const DWModal = ({
  text,
  handleNewCard = () => {},
  handleConfirmClick = () => {},
  setshowModalData = () => {},
  isNewCard = false,
  onConfirmCard = () => {},
  isResultModal,
  askedQuestion,
  winnerPlayer,
  winnerCard,
  screens
}) => {
  const [cancelSelect, setCancelSelect] = useState(false);

  const AskedQuestion = askedQuestion?.replace(/\[BLANK\]/g, "_______");
  const response_card_text = _.get(screens, "response_card_text ");

  const handleShowModal = () => {
    setCancelSelect(true);
    setshowModalData({});
  };

  const handleConfirmClickWrapper = () => {
    onConfirmCard && onConfirmCard();
    handleConfirmClick();
  };
  const new_card_button_text = _.get(
    screens,
    "2_playing.other.new_card_button_text",
    "CONFIRM"
  );
  const cancel_button_text = _.get(
    screens,
    "2_playing.other.cancel_button_text",

    "Cancel"
  );
  const selection_label = _.get(
    screens,
    "2_playing.other.selection_label",

    "Your Selection"
  );
  const new_card_label = _.get(
    screens,
    "2_playing.other.new_card_label",

    "Your New Card"
  );
  return (
    <motion.div
      variants={
        cancelSelect ? slide_bounce_down_variants : slide_bounce_variants
      }
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-modal"
      onClick={handleNewCard}
    >
      <div className="dw-modal__dialog">
        <div className="dw-modal__content">
          {/* first modal */}
          {!isResultModal ? (
            <>
              <p>{isNewCard ? new_card_label : selection_label}</p>
              <div className="sel-card">
                <p className="text">{text}</p>
                <p className="hash-text">#DoneWith2020</p>
              </div>

              <button
                className="confirm-btn"
                onClick={isNewCard ? handleNewCard : handleConfirmClickWrapper}
              >
                {new_card_button_text}
              </button>

              {!isNewCard && (
                <motion.button
                  variants={divVariants}
                  className="cancel-btn"
                  onClick={handleShowModal}
                >
                  {cancel_button_text}
                </motion.button>
              )}
            </>
          ) : (
            <>
              <div className="text-center">
                <img
                  src={winnerPlayer?.profile_image}
                  className="img-fluid user-img"
                  alt=""
                />
              </div>
              <p>{winnerPlayer?.display_name}</p>
              <div className="que-card">
                <p className="txt">{AskedQuestion}</p>
              </div>
              <div className="sel-card">
                <p className="text">{`"${winnerCard?.card?.text}"`}</p>
                <p className="hash-text">#DoneWith2020</p>
              </div>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default DWModal;
